import { Body, colors, Margin } from '@spritz-finance/ui'
import React from 'react'
import styled from 'styled-components'

const OptionButton = styled.button<{
    clickable?: boolean
}>`
    color: var(--text-primary, #333);
    display: flex;
    background: var(--background-primary, ${colors.white});
    padding: ${Margin.Small};
    &:hover {
        cursor: pointer;
        border-color: var(--text-primary, transparent);
        box-shadow: 10px 10px 40px 0px var(--card-hover-shadow, rgba(0, 0, 0, 0.15));
    }
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    outline: none;
    border: 1px solid ${colors.charcoal};
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
    &:hover {
        cursor: ${({ clickable }) => clickable && 'pointer'};
    }
`

const OptionCardLeft = styled.div``

const SubHeader = styled.div`
    margin-top: 10px;
    font-size: 12px;
`

const IconWrapper = styled.div<{ size?: number | null }>`
    align-items: center;
    justify-content: center;
    padding-right: 12px;
    & > img,
    span {
        height: ${({ size }) => (size ? size + 'px' : '28px')};
        width: ${({ size }) => (size ? size + 'px' : '28px')};
    }
`

const StyledLink = styled.a`
    display: flex;
    text-decoration: none;
    ${OptionButton} {
        width: 100%;
    }
`

export default function Option({
    link = null,
    clickable = true,
    size,
    onClick = null,
    header,
    subheader,
    icon,
    isActive = false,
}: {
    link?: string | null
    clickable?: boolean
    size?: number | null
    onClick?: null | (() => void)
    header: React.ReactNode
    subheader?: React.ReactNode
    icon: string
    isActive?: boolean
}) {
    const content = (
        <OptionButton onClick={() => onClick?.()} clickable={clickable && !isActive}>
            <OptionCardLeft>
                <Body.SmBold size={16}>{header}</Body.SmBold>
                {subheader && <SubHeader>{subheader}</SubHeader>}
            </OptionCardLeft>
            <IconWrapper size={size}>
                <img src={icon} alt="Wallet icon" />
            </IconWrapper>
        </OptionButton>
    )

    if (link) {
        return (
            <StyledLink href={link} target="_blank">
                {content}
            </StyledLink>
        )
    }

    return content
}
